var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30281 8.70835C6.01742 8.42288 5.94066 8.00774 6.07251 7.65251L6.17471 7.45101C6.21131 7.39556 6.25401 7.34296 6.30281 7.29414L6.30281 7.29413L6.30491 7.29204L8.42345 5.17282C8.81385 4.7823 9.44682 4.7823 9.83721 5.17282C10.2276 5.56334 10.2276 6.19651 9.83722 6.58703L9.42183 7.00256L15.0613 7.00256C15.6136 7.00256 16.0613 7.45027 16.0613 8.00256C16.0613 8.55484 15.6136 9.00256 15.0613 9.00256L9.42446 9.00256L9.83722 9.41545C10.2276 9.80598 10.2276 10.4391 9.83722 10.8297C9.44682 11.2202 8.81386 11.2202 8.42346 10.8297L6.30636 8.71189L6.30281 8.70835Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 0 2 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2L2 2V14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H2C0.89543 16 0 15.1046 0 14V2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIn);
export default __webpack_public_path__ + "static/media/transfer-in.e3ce47bacfbcaf028d285702fe204790.svg";
export { ForwardRef as ReactComponent };